module.exports = __webpack_public_path__ + "img/PANTALLA-03.02e0face.png";